<mat-sidenav-container class="sidenav-container" (click)="onSideNavToggle($event)">
    <mat-sidenav #leftSidenav mode="side" opened [ngClass]="sideNavState ? 'opened-icon' : 'closed-icon'">
        <div
            class="sidenav_container"
            [@onSideNavChange]="sideNavState ? 'open' : 'close'"
            [ngClass]="sideNavState ? 'opened' : 'closed'"
        >
            <div class="logo-row">
                <div class="logo-wrapper">
                    <img class="logo-large" src="assets/aumico-logo-4c-white.svg" />
                    <img class="logo-small" src="assets/aumico-logo-small.svg" />
                </div>
            </div>

            <div fxLayout="column" class="primary-nav-row" fxLayoutAlign="stretch">
                <div>
                    <mat-nav-list class="primary nav-list">
                        <ng-content select="[primary-links]"></ng-content>
                    </mat-nav-list>
                </div>

                <div fxFlex="100">
                    <mat-divider></mat-divider>
                    <div></div>
                </div>
                <div class="referral">
                    <ng-content select="[referral-invite]"></ng-content>
                </div>
                <div>
                    <mat-nav-list class="organization nav-list">
                        <ng-content select="[organization-links]"></ng-content>
                    </mat-nav-list>
                </div>

                <div>
                    <mat-nav-list class="secondary nav-list">
                        <ng-content select="[secondary-links]"></ng-content>
                    </mat-nav-list>
                </div>
                <div>
                    <mat-nav-list class="secondary nav-list">
                        <ng-content select="[support-links]"></ng-content>
                    </mat-nav-list>
                </div>

                <div class="user nav-list">
                    <div>
                        <mat-nav-list class="user-nav">
                            <ng-content select="[user-links]"></ng-content>
                        </mat-nav-list>
                    </div>
                </div>
            </div>

            <span class="spacer"></span>
        </div>
    </mat-sidenav>

    <mat-sidenav-content [class.collapsed]="!sideNavState" [@onMainContentChange]="sideNavState ? 'open' : 'close'">
        <div class="main_content">
            <ng-content select="[content]"></ng-content>
        </div>
    </mat-sidenav-content>
</mat-sidenav-container>
